export default __webpack_public_path__ + "static/media/selecao.cfaa1ad0.webp";